var map = {
	"./de_DE.json": [
		923,
		2
	],
	"./en_AU.json": [
		924,
		3
	],
	"./en_GB.json": [
		925,
		4
	],
	"./en_US.json": [
		926,
		5
	],
	"./es_AR.json": [
		927,
		6
	],
	"./es_ES.json": [
		928,
		7
	],
	"./es_MX.json": [
		929,
		8
	],
	"./fr_CA.json": [
		930,
		9
	],
	"./fr_FR.json": [
		931,
		10
	],
	"./it_IT.json": [
		932,
		11
	],
	"./nl_NL.json": [
		933,
		12
	],
	"./pt_BR.json": [
		934,
		13
	],
	"./pt_PT.json": [
		935,
		14
	],
	"./sv.json": [
		936,
		15
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 920;
module.exports = webpackAsyncContext;